import React from "react";
import { FaPhoneAlt } from "react-icons/fa";

const BottomPromoCard = () => {
  return (
    <div className="block md:hidden fixed bottom-4 left-0 w-full px-3 z-50">
      <div className="
        bg-white/90 backdrop-blur-xl 
        border border-gray-200 
        shadow-xl rounded-2xl 
        px-4 py-3 
        flex items-center justify-between
      ">
        
        {/* LEFT — Agent + Message */}
        <div className="flex items-center gap-3">
          <img
            src="/assets/agent.png"
            alt="Agent"
            className="w-12 h-12 rounded-full border border-gray-300 shadow-sm"
          />

          <div className="leading-tight">
            <p className="text-[11px] text-gray-700">
              <span className="font-semibold text-gray-900">Phone-only deal: </span>
              Use code 
              <span className="bg-yellow-300 text-gray-900 font-bold px-1 rounded ml-1">
                CALL50
              </span>
            </p>

            <p className="text-[12px]">
              Call Now{" "}
              <a href="tel:+18887112909" className="text-teal-600 font-bold">
                +1 888-711-2909
              </a>
            </p>
          </div>
        </div>

        {/* RIGHT — Call Button */}
        <a
          href="tel:+18887112909"
          className="
            bg-teal-600 
            hover:bg-teal-700 
            text-white 
            p-3 
            rounded-full 
            shadow-lg 
            active:scale-95 
            transition-all 
          "
        >
          <FaPhoneAlt className="text-lg" />
        </a>
      </div>
    </div>
  );
};

export default BottomPromoCard;
